var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.7 219.4H211.8V121.2C211.8 117.9 209.9 115.9 207.5 115.9H179.6C177.3 115.9 175.3 117.8 175.3 120.2V219.4H160.1V155.8C160.1 152.5 157.2 150.5 154.8 150.5H127.9C125.6 150.5 123.6 152.4 123.6 154.8V219.4H108.4V164.4C108.4 161.1 106.5 159.1 104.1 159.1H76.1C73.8 159.1 71.8 161 71.8 163.4V219.4H59.9C57.6 219.4 55.6 221.3 55.6 223.7C55.6 226.1 57.5 229 59.9 229H223.7C226 229 228 226.1 228 223.7C228 221.3 226 219.4 223.7 219.4ZM98.7 219.4H81.4V168.7H98.6L98.7 219.4ZM150.4 219.4H133.2V160H150.4V219.4ZM203.1 219.4H183.9V125.6H203.1V219.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9 150.4C62.1 150.4 63.1 149.9 63.9 149.1L104.5 108.7L134.9 131.3C136.6 132.9 138.4 133.3 140.5 131.8L202.2 70.2V85.7C202.2 88 204.1 90 206.5 90C208.8 90 210.8 88.1 210.8 85.7V59.8C210.9 59.2 210.9 58.7 210.8 58.2C210.3 56.9 209.4 56 208.1 55.5C207.5 55.4 207 55.4 206.5 55.5H180.6C178.3 55.5 176.3 57.4 176.3 59.8C176.3 62.1 178.2 64.1 180.6 64.1H196L138 122.1L106.6 98.5C104.8 97.2 101.5 98.3 100 100L56.9 143C55.3 144.5 55.1 147.2 56.7 148.9C56.8 149 56.8 149 56.9 149.1C57.6 149.9 59.7 150.4 60.9 150.4Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chart.92f51187.svg";
export { ForwardRef as ReactComponent };